export default {
  DefaultLanguage: 'en',
  DefaultDownloadSize: 0.5,
};
